module.exports = __webpack_public_path__ + "img/hipermax.5be65877.png";